export const resume_canidates_table_columns = [
  { id: "selector", label: "" },
  { id: "name", label: "Name" },
  // { id: "overall_score", label: "Overall Score" },
  { id: "score", label: "Resume Screening results" },
  { id: "stage", label: "Stage" },
  { id: "created_at", label: "Resume dropped on" },
  { id: "action", label: "Action" },
];

export const interview_candidates_table_columns = [
  { id: "expand", label: "" },
  { id: "name", label: "Name" },
  { id: "overall_score", label: "Overall Score" },
  { id: "interview_score", label: "Interview results" },
  { id: "stage", label: "Stage" },
  { id: "created_at", label: "Interview Attempt on" },
  { id: "resume_droped", label: "Resume Dropped on" },
  { id: "violation_detected", label: "Violation detected" },
  { id: "Action", label: "Action" },
];

export const results_dashbodard_resume_table_columns = [
  { id: "name", label: "Name" },
  { id: "attempts", label: "Candidates Attempts" },
  { id: "status", label: "Status" },
  { id: "progress", label: "Progress" },
  { id: "last_activity", label: "Last activity" },
  { id: "created_at", label: "Created On" },
  { id: "expiry_date", label: "Expiry date" },
  { id: "action", label: "Action" },
];

export const results_dashbodard_interview_table_columns = [
  { id: "name", label: "Name" },
  // { id: "progress", label: "Stage" },
  { id: "attempts", label: "Candidates Attempts" },
  { id: "last_activity", label: "Last activity" },
  { id: "created_at", label: "Created On" },
  { id: 'action', label: 'Action' },
];
